module.exports = __webpack_public_path__ + "img/semi_driving.56f316d4.svg";